// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2057":"3e70ceca","3635":"ca6099bb","4477":"bbc4bc22","5156":"f727b7d0","6919":"f727b7d0","9685":"380ba3b2","9735":"bbc4bc22"}[chunkId] + ".chunk.css";
};